@if (orders && orders.length) {
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Orders ({{ orders.length }})</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="orders-list">
        @for (order of orders; track order.orderNo) {
          @if (order.orderExists) {
            <a [routerLink]="['/orders', order.orderNo]">{{ order.orderNo }}</a>
          } @else {
            <span>{{ order.orderNo }}</span>
          }
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}
